module.exports = __webpack_public_path__ + "media/ab-homepage/devices-6bda65bf.png";